/**
 * class pro komunikaci s API ČESKÝINTERNET.cz v1.0
 * @author: Petr Klimes <petr.klimes@ci.cz>
 */

import axios, { AxiosResponse } from 'axios'

const http = axios.create({
    baseURL: 'https://api.ci.cz',
    headers: {
        'Content-type': 'application/json',
    },
})

interface CrmProduktInformaceInterface {
    id: number,
    nazev_produktu: string,
    nazev_produktu_kratky: string,
    nazev_produktu_platba: string,
    zadat_pocet: number,
    zadat_kategorie_min_delka: number,
    zadat_kategorie_max_delka: number,
    zadat_kategorie_presna_delka: number,
    zadat_region: number,
    zadat_okres: number,
    zadat_mesic_rok: number,
    doba_plneni: number,
    pouze_k_produktum: string,
    cena_bez_dph: number,
    cena_za_pocet_dni: number,
    cena_za_pocet_ks: number,
    dalsi_region_procent: number
}

interface CrmOrderInterface {
    id_historie: number,
    hash_objednavky: string,
    cislo_faktury: number,
    cena: number
}

enum Crm {
    CeskeStavby = 4,
    CeskeReality = 1,
    HotelyPenziony = 6
}

enum Platba {
    ProformaFaktura = 1,
    PlatebniBrana = 3
}

class CrmService {
    /**
     * vytvori objednavku z nabidky
     * @param crm
     * @param id_firmy
     * @param opravny_kod
     * @param id_historie
     * @param hash_objednavky
     * @param platba
     */
    getVytvoreniObjednavkyZNabidky(
        crm: number,
        id_firmy: number,
        opravny_kod: string,
        id_historie: number,
        hash_objednavky: string,
        platba: number
    ) {
        return http.get(
            `/crm/1.0/vytvoreni_objednavky_z_nabidky/?crm=${crm}&id_firmy=${id_firmy}&opravny_kod=${opravny_kod}&id_historie=${id_historie}&hash_objednavky=${hash_objednavky}&platba=${platba}`
        )
    }

    /**
     * vytvori objednavku v CRM
     */
    getObjednavkaZalozeni(
        params: {
            crm: number,
            id_firmy: number,
            opravny_kod: string,
            platba: number,
            cena_bez_dph?: number,
            cena_s_dph?: number,
            sandbox?: number
        }
    ) {
        return http.get(
            // `/crm/1.0/objednavka_zalozeni/?crm=${crm}&id_firmy=${id_firmy}&opravny_kod=${opravny_kod}&platba=${platba}&cena_bez_dph=${cena_bez_dph}&sandbox=${sandbox}`
            `/crm/1.0/objednavka_zalozeni/`,
            {
                params
            }
        )
    }

    /**
     * zapise do CRM zaplaceni objednavky
     * @param crm
     * @param id_firmy
     * @param opravny_kod
     * @param id_historie
     * @param hash_objednavky
     * @param platba
     * @param sandbox
     */
    getObjednavkaZaplacena(
        crm: number,
        id_firmy: number,
        opravny_kod: string,
        id_historie: number,
        hash_objednavky: string,
        platba: number,
        sandbox: number
    ) {
        return http.get(
            `/crm/1.0/objednavka_zaplacena/?crm=${crm}&id_firmy=${id_firmy}&opravny_kod=${opravny_kod}&id_historie=${id_historie}&hash_objednavky=${hash_objednavky}&platba=${platba}&sandbox=${sandbox}`
        )
    }

    /**
     * zmeni zpusob platby 1=platba proforma fakturou, 3=platba platebni branou
     * @param crm
     * @param id_firmy
     * @param opravny_kod
     * @param id_historie
     * @param hash_objednavky
     * @param platba
     * @param sandbox
     */
    getZmenaVybranehoZpusobuPlatby(
        crm: number,
        id_firmy: number,
        opravny_kod: string,
        id_historie: number,
        hash_objednavky: string,
        platba: number,
        sandbox: number
    ) {
        return http.get(
            `/crm/1.0/zmena_vybraneho_zpusobu_platby/?crm=${crm}&id_firmy=${id_firmy}&opravny_kod=${opravny_kod}&id_historie=${id_historie}&hash_objednavky=${hash_objednavky}&platba=${platba}&sandbox=${sandbox}`
        )
    }

    /**
     *
     * @param id_produktu
     */
    getProduktInformace(id_produktu: number) {
        return http.get(`/crm/1.0/produkt_informace/?id_produktu=${id_produktu}`)
    }

    postNakup(
        params: {
            crm: number,
            id_firmy: number,
            opravny_kod: string,
            id_historie: number,
            hash_objednavky: string,
            id_produktu: number,
            pocet: number,
            sandbox: number,
            cena_bez_dph?: number,
            cena_s_dph?: number
        }
    ) {
        return http.post(
            `/crm/1.0/objednavka_nakupy/`,
            JSON.stringify(params)
        )
    }
}

const crmService = new CrmService()

export { CrmProduktInformaceInterface, CrmOrderInterface, crmService }
